import { Field, useFormikContext } from 'formik';
import PropTypes from 'prop-types';

const Bedding = ({ options }) => {
  const { values, setFieldValue } = useFormikContext();

  return (
    <div className="py-4 space-y-3 d-flex flex-column border-top">
      <h4 className="mb-1">Bedding configuration</h4>
      {options.map((bed) => (
        <label key={bed.id} className="d-flex">
          <Field
            className="form-check-input me-2"
            type="radio"
            role="switch"
            name="bedRequirement"
            onChange={(event) => {
              setFieldValue('bedRequirement', Number(event.target.value));
            }}
            value={bed.id}
            checked={values.bedRequirement === bed.id}
          />
          {bed.name}
        </label>
      ))}
    </div>
  );
};

Bedding.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      number: PropTypes.string,
    })
  ),
};

export default Bedding;
